import { createSignal, type Signal } from "solid-js"
import type { Nullable } from "../../typescript"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export const useTouchStartEventSignal = createSharedCachedFactory((): Signal<Nullable<TouchEvent | null>> => {
  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<Nullable<TouchEvent | null>>()

  return signal
})


